var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <form ng-if=\"$ctrl.showLogin()\"> Username\n<input type=\"text\" ng-model=\"$ctrl.username\"/> <br/> Password <input type=\"password\" ng-model=\"$ctrl.password\"/> <br/> <button ng-disabled=\"$ctrl.status === 'logging-in'\" type=\"button\" ng-click=\"$ctrl.login()\">Log in</button> </form> <button type=\"button\" ng-if=\"$ctrl.showLogout()\" ng-click=\"$ctrl.logout()\">Log out</button> <p> DEBUG: Status is '{{ $ctrl.status }}'. </p> </web-component>";
var id1="winresLogin.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresLogin/winresLogin.html
// module id = 312
// module chunks = 2